import { render } from "./button.vue?vue&type=template&id=b08f0674&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./button.vue?vue&type=style&index=0&id=b08f0674&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src16451840/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b08f0674"]])

export default __exports__